// default configurations in all the production/uat/local environments
module.exports = {
    env: "production",
    header: "",
    bulkFxStartTime: "09:00:00",
    bulkFxEndTime: "16:00:00",
    publicHolidays: {
        sg: [
            "2021-11-04",
            "2021-12-25",
            "2022-01-01",
            "2022-02-01",
            "2022-02-02",
            "2022-04-15",
            "2022-05-01",
            "2022-05-02",
            "2022-05-03",
            "2022-05-15",
            "2022-05-16",
            "2022-07-09",
            "2022-08-09",
            "2022-10-24",
            "2022-12-25",
            "2022-12-26",
        ]
    },
    swiftTargetCcyBankCharges: ["USD", "EUR", "JPY", "NZD", "CHF", "GBP"],
    captChaApiKey: "KdWS6/PSP5QCOFX0vTDKoSukLq5TzjeftmZflVd3DyuhXbLjza/NyW1kznmBklb+pmvLwTfOgCUxG87iOml7a5tcYPzOmLQT0vV9PcxoqF+BvOEVuNMiiwjcRmk+uwxSBeswBBchRDVsXDmS2hsg1agHE2LX7fEdegCFidxEAz0WIW/sGHdzNPvC82FN2/2ouaRLVD75Xjt4VrsPmMPgBjbcTfxe80wUoWr9mAyUE5o2HCoWiOXU2Xv50KQFOEYr6j0UH4SQqCorv0L2HMtlh0EKpon1vw61K6Cqhvi4gfIYM/EbDCo/KQo6unGrF6SIEBUm+ZNKq/joenYVlzjAyrEVf6Lj2gP4wekoCOJbxNw4Ta25S+BphI7dmqU/Lr5L0Bf3xN0ULtynv13Once4i5g03BzStGcpHBBVuVbXfLC/sZJeYiSsSwlZVBDrIXzxj14fvrmbWvlecsXRp7CCweslU5BvTy50bOyytTTxuP6Phr5O+NHjSaMuuOEHSdGUodpnEdlb+ESu9hM+9bCij1CVX2T28QTZ1lPc0PROSO/mhhddL98klFad1nEznDho+k/XFmoNpJUmRm9hNvy701oQDfKszH7hq9/bRaiGfDrEZIzSOkB17SP4yIfMuFrKmbWauFCtgmLaXcM6nw0GRxmThuTNA2Rkw2WXQ54hHHE=_1_1"

};
  